import { action, observable } from "mobx";
import { persist, create } from 'mobx-persist';
import CompanyService from 'services/CompanyService';
import Api from 'utils/Api';

class SiteProviderStoreClass {

  @persist @observable logo = ''
  @persist @observable mail = ''
  @persist @observable phone = ''
  @persist @observable cel = ''
  @persist @observable address = ''
  @persist @observable facebook = ''
  @persist @observable twitter = ''
  @persist @observable instagram = ''
  @persist @observable themeColor = ''

  @persist('object') @observable metricOne = {
    metric_order: 1,
    metric: '',
    name: '',
    description: '',
  }

  @persist('object') @observable metricTwo = {
    metric_order: 2,
    metric: '',
    name: '',
    description: '',
  }

  @persist('object') @observable metricThree = {
    metric_order: 3,
    metric: '',
    name: '',
    description: '',
  }
  
  
  @action
  updateLogo(value){
    this.logo = value
  }

  @action
  updateMetricOneForm(name,value){
    this.metricOne[name] = value
  }

  @action
  updateMetricTwoForm(name,value){
    this.metricTwo[name] = value
  }

  @action
  updateMetricThreeForm(name,value){
    this.metricThree[name] = value
  }

  @action
  updateAddressAndContact(name,value){
    this[name] = value
  }

  @action
  updateSocialNetwork(name,value){
    this[name] = value
  }

  @action
  updateThemeColor(value){
    this.themeColor = value
    //console.log("theme_color",this.theme_color)
  }


  @action
  postToAPI(){

    let data = {
      logo: this.logo,
      metrics: [
        this.metricOne,
        this.metricTwo,
        this.metricThree
      ],
      mail: this.mail,
      phone: this.phone,
      cel: this.cel,
      address: this.address,
      facebook: this.facebook,
      instagram: this.instagram,
      twitter: this.twitter,
      theme_color: this.themeColor
    }
    
    return Api.call('/company/save-my-site-info', 'post', data, false, true)
    .then(res => {
        if(Array.isArray(res.data.data)){
          res.data.data.forEach(item => {
            switch (item.metric_order) {
              case 1:
                this.metricOne = item;
                break;
              case 2:
                this.metricTwo = item;
                break;
              case 3:
                this.metricThree = item;
                break;
              default:
                break;
            }
          });
        }
        // Examine the text in the response
        console.log("dados enviados pela store e salvos no bd ----------",res.data.data);
      }
    )
    .catch(function(err) {
      console.log('Fetch Error :-S', err);
    });

  }

  @action
  uploadLogo(data) {
    return CompanyService.updateLogo(data)
    .then(res => {
      this.logo = res.data.my_site_logo
    })
    .catch(err => {
      console.error('SiteProviderStore.uploadLogo error')
      throw err;
    })
  }

  @action
  loadSiteInfo(data) {
    this.logo = data.my_site_logo || ''
    this.mail = data.my_site_address_contact_mail || ''
    this.phone = data.my_site_address_contact_phone || ''
    this.cel = data.my_site_address_contact_cel || ''
    this.address = data.my_site_address_contact_address || ''
    this.facebook = data.my_site_social_network_facebook || ''
    this.instagram = data.my_site_social_network_instagram || ''
    this.twitter = data.my_site_social_network_twitter || ''
    this.themeColor = data.my_site_theme_color || ''
    if (Array.isArray(data.company_metrics)) {
      data.company_metrics.forEach(metric => {
        switch (metric.metric_order) {
          case 1:
            this.metricOne = metric;
            break;
          case 2:
            this.metricTwo = metric;
            break;
          case 3:
            this.metricThree = metric;
            break;
          default:
            break;
        }
      })
    }
  }

}


export const SiteProviderStore = new SiteProviderStoreClass();

create({})('SiteProviderStore', SiteProviderStore)


// WEBPACK FOOTER //
// ./src/modules/site/SiteProviderStore.js